import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  brandName: "Patna Bakery",
  title: "Bakery in Patna, Bihar | Fresh Cakes & Desserts",
  description:
    "Fresh cakes, pastries, cookies and desserts in Patna, Bihar. Order online for delivery or pickup.",
  locale: "en_IN",
  city: "Patna",
  region: "Bihar",
  country: "IN",
};

function toAbsoluteUrl(maybeRelativeUrl) {
  const v = String(maybeRelativeUrl || "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  if (typeof window === "undefined") return v;
  return new URL(v, window.location.origin).toString();
}

function buildCanonicalUrl(canonicalPathOrUrl) {
  const v = String(canonicalPathOrUrl || "").trim();
  if (!v) {
    if (typeof window === "undefined") return "";
    return window.location.href;
  }
  return toAbsoluteUrl(v);
}

/**
 * Lightweight SEO helper for CRA routes.
 * Note: This improves metadata + rich results, but SPA HTML is still client-rendered.
 */
export default function Seo({
  title,
  description,
  canonical,
  noIndex = false,
  ogImage,
  jsonLd,
}) {
  const t = String(title || DEFAULTS.title).trim();
  const d = String(description || DEFAULTS.description).trim();
  const c = buildCanonicalUrl(canonical);
  const og = ogImage ? toAbsoluteUrl(ogImage) : "";

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />

      {c ? <link rel="canonical" href={c} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:locale" content={DEFAULTS.locale} />
      <meta property="og:site_name" content={DEFAULTS.brandName} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      {c ? <meta property="og:url" content={c} /> : null}
      {og ? <meta property="og:image" content={og} /> : null}

      <meta name="twitter:card" content={og ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      {og ? <meta name="twitter:image" content={og} /> : null}

      <meta name="geo.region" content={`${DEFAULTS.country}-${DEFAULTS.region}`} />
      <meta name="geo.placename" content={`${DEFAULTS.city}, ${DEFAULTS.region}`} />

      {noIndex ? <meta name="robots" content="noindex, nofollow" /> : null}

      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}

